module.exports = ".text-upper {\n  text-transform: uppercase; }\n"